module.exports = __webpack_public_path__ + "img/appointment-no.6ce53a36.svg";